import DisplayValueDate from './DisplayValueDate';
import DisplayValueRollingDatePoint from './DisplayValueRollingDatePoint';
import isString from 'transmute/isString';
import { jsx as _jsx } from "react/jsx-runtime";
const DisplayValueDateStaticOrDynamic = props => {
  const {
    value,
    operator,
    getIsUngated
  } = props;
  if (value) {
    return isString(value) ? /*#__PURE__*/_jsx(DisplayValueDate, {
      value: value,
      operator: operator,
      getIsUngated: getIsUngated
    }) : /*#__PURE__*/_jsx(DisplayValueRollingDatePoint, {
      value: value
    });
  }
  return null;
};
export default DisplayValueDateStaticOrDynamic;